import React from "react";
import { Card, Avatar, Typography, Tag } from "antd";

const { Title, Text } = Typography;

const UserDetails = ({user}) => {

    return (
        <div style={{
            display: 'flex',
            justifyContent: "center",
            alignItems : "center"
    }}> 
            
    
            <Card style={{ width: 400, textAlign: "center", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", borderRadius: "10px", background: "#fff" }}>
                <Avatar size={100} src={user?.profilePic} alt={user?.name} style={{ marginBottom: 20, border: "2px solid #1890ff" }} />
                <Title level={3} style={{ color: "#1890ff" }}>{user?.name}</Title>
                <Text strong>Email:</Text> <Text>{user?.email}</Text> <br />
                <Text strong>Email Verified:</Text> {user?.emailVerified ? <Tag color="green">Verified</Tag> : <Tag color="red">Not Verified</Tag>} <br />
                <Text strong>Phone:</Text> <Text>{user?.countryCode} {user?.phoneNumber}</Text> <br />
                <Text strong>Phone Verified:</Text> {user?.phoneVerified ? <Tag color="green">Verified</Tag> : <Tag color="red">Not Verified</Tag>} <br />
                <Text strong>Designation:</Text> <Text>{user?.designation}</Text> <br />
                {user?.businessName && (
                    <>
                        <Text strong>Business Name:</Text> <Text>{user?.businessName}</Text> <br />
                    </>
                )}
                {user?.businessCategory && (
                    <>
                        <Text strong>Business Category:</Text> <Text>{user?.businessCategory}</Text> <br />
                    </>
                )}
                {user?.industryType && (
                    <>
                        <Text strong>Industry Type:</Text> <Text>{user?.industryType}</Text> <br />
                    </>
                )}
                {user?.gstNumber && (
                    <>
                        <Text strong>GST Number:</Text> <Text>{user?.gstNumber}</Text> <br />
                    </>
                )}
                {user?.businessAddress && (
                    <>
                        <Text strong>Business Address:</Text> <Text>{user?.businessAddress.address}, {user?.businessAddress.city}, {user?.businessAddress.state}, {user?.businessAddress.country}, {user?.businessAddress.postalCode}</Text>
                    </>
                )}
                {user?.businessOverview && (
                    <>
                        <Text strong>Business Overview:</Text> <Text>{user?.businessOverview}</Text> <br />
                    </>
                )}
            </Card>
        </div>
    );
};

export default UserDetails;